import { render } from "./LocationEdit.vue?vue&type=template&id=5d773f8a"
import script from "./LocationEdit.vue?vue&type=script&lang=js"
export * from "./LocationEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__